/* eslint-disable */
/**
 * @author Leonel Martinez
 * @module powerbox
 * @fileoverview `Vuex powerbox module` that comes back from the settings API.
 */
import { powerboxService } from "@/services";
import { MESSAGES } from "@/utils";
import { rootAction } from "../index";
import i18n from "@/i18n";

export const powerbox = {
  namespaced: true,
  state: {
    vehicleResults: [],
    partsResults: []
  },
  actions: {
    GET_VEHICLES: async ({ commit, dispatch }, request) => {
      const response = await powerboxService.searchVehicles(request.value, request.maxSize);
      console.log("Response:", response);

      if (response.statusText != "OK") {
        dispatch("snackbar/SHOW_SNACKBAR", { ...MESSAGES.ERROR.SEARCH_VEHICLE, text: `${i18n.tc("ErrorMessages.SearchVehicle")}${request}` }, rootAction);
        return;
      }

      commit("SET_VEHICLES", response.data);
    },
    GET_P2V_VEHICLES: ({ commit, dispatch }, request) => new Promise((resolve) => {
      setTimeout(() => {
        powerboxService.searchP2VVehicles(request).then(
          results => {
            if (!results.vehicleWithVins) {
              dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.PLATE_NOT_FOUND, { root: true });
            }
            commit("SET_VEHICLES", results);
            resolve(results)
          },
          error => {
            dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.SERVER_ERROR, { root: true });
            throw new Error("HTTP REQUEST ERROR", error)
          }
        )
      }, 250)
    }),
    GET_PARTS: async ({ dispatch, commit }, request) => {
      const response = await powerboxService.searchParts(request.value, request.maxSize);

      if (response.statusText != 'OK') {
        dispatch("snackbar/SHOW_SNACKBAR", { ...MESSAGES.ERROR.GET_PARTS, text: `${i18n.tc("ErrorMessages.GetParts")}${request}`, }, { root: true });
        return;
      }

      commit("SET_PARTS", response.data);
    },
    GET_VEHICLES_AND_PARTS: ({ commit }, request) => new Promise((resolve) => {
      setTimeout(() => {
        powerboxService.multisearch(request).then(
          results => {
            commit("SET_VEHICLES", results.vehicles);
            commit("SET_PARTS", results.parts);
            resolve(results)
          },
          error => {
            dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.SERVER_ERROR, { root: true });
            console.warn("HTTP REQUEST ERROR", error);
          }
        )
      }, 250)
    }),
    RESET_VEHICLES_PARTS({commit}) {
      commit("RESET_VEHICLES_PARTS")
    }
  },
  mutations: {
    SET_VEHICLES(state, results) {
      state.vehicleResults = results
    },
    SET_PARTS(state, results) {
      state.partsResults = results
    },
    RESET_VEHICLES_PARTS(state) {
      state.vehicleResults = []
      state.partsResults = []
    }
  }
}